module.exports = __webpack_public_path__ + "e53a56f93e114accafadf2b5e91be9d3.fbx";